import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { ThreeDotsLoader } from "../commonComponent/loader";
import SortableTable from "./SortableTable";
import ToggleSwitch from "../commonComponent/toggleSwitch";
import picLogo from "../../assets/images/input_logo1.png";
import botLogo from "../../assets/images/output_logo.png";
import mimic from "../../assets/gif/mimic.gif";
import namaste from "../../assets/gif/namaste.gif";
import loader1 from "../../assets/gif/loader1.gif";
import music from "../../assets/audio/music.mp3";
import editIcon from "../../assets/images/Edit.svg";
import { useTranslation } from "react-i18next";
import styled, { keyframes } from "styled-components";

const ChatMessages = ({
  chatbotInput,
  chatbotOutput,
  chatTimestamps,
  responseTimestamps,
  loading,
  error,
  fontSize,
  isChecked,
  onToggle,
  playingAudioIndex,
  setPlayingAudioIndex,
  audioRefs,
  questionLoading,
  correctedInput,
  backgroundMusicRef,
  waitingAudioRef,
  waitingAudio,
  onWaitingStart,
  setIsSourceDataModelOpen,
  generateTimestamp,
  handleCopy,
  paragraphRef,
  onFollowUpClick,
  onEditQuestion,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {chatbotInput.map((item, index) => (
        <React.Fragment key={index}>
          {/* User bubble */}
          <div className="flex min-w-0 items-start justify-end gap-x-2 mx-2 sm:gap-x-3 sm:mx-5 my-5" ref={paragraphRef}>
            <button
              type="button"
              onClick={() => onEditQuestion?.(item)}
              // disabled={!onEditQuestion || loading}
              className="mt-2 h-6 w-6 shrink-0 cursor-pointer rounded bg-transparent p-0 transition hover:scale-105 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#008787] disabled:cursor-not-allowed disabled:opacity-50"
              title="Edit question"
              aria-label="Edit question"
            >
              <img src={editIcon} alt="" aria-hidden="true" className="h-6 w-6" />
            </button>
            <div
              className="resize-none flex min-w-0 flex-col justify-center items-end bg-transparent overflow-x-hidden"
              style={{
                flex: "0 1 auto",
                width: "fit-content",
                maxWidth: "min(560px, calc(100% - 88px))",
              }}
            >
              <div
                className="shadow-md bg-[#005856] text-white relative"
                style={{
                  border: "1px solid #00706d",
                  borderRadius: 8,
                  maxWidth: "min(560px, 100%)",
                  width: "fit-content",
                  padding: "11px 18px",
                }}
              >
                <div className="flex flex-col gap-0">
                  <div style={{ lineHeight: 1.38 }}>
                    <span
                      className="text-white text-sm"
                      style={{
                        display: "block",
                        fontSize: `${fontSize}px`,
                        lineHeight: 1.38,
                        overflowWrap: "anywhere",
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                      }}
                    >
                      {item}
                    </span>
                  </div>
                </div>
              </div>
              <span
                className="text-gray-500 text-[13px] font-medium italic ml-auto"
                style={{ fontSize: `${Math.max(fontSize - 2, 10)}px` }}
              >
                {chatTimestamps[index] || generateTimestamp()}
              </span>
            </div>
<div className="w-[40px] h-[40px] flex items-center justify-center rounded-full overflow-hidden">
  <div className="w-full h-full rounded-full bg-white flex items-center justify-center overflow-hidden">
    <img
      src={picLogo}
      alt=""
      aria-hidden="true"
      className="w-full h-full object-cover rounded-full"
    />
  </div>
</div>
          </div>

          {/* Bot response */}
          {chatbotOutput?.length > 0 && chatbotOutput[index] && (
            <div
              className="flex min-w-0 gap-x-2 text-left mx-2 sm:gap-x-3 sm:mx-4"
            >
           <div className="w-[40px] h-[40px] shrink-0 flex items-center justify-center rounded-full overflow-hidden"
  style={{ background: "linear-gradient(135deg, #005856, #00a897)", padding: "2px" }}>
  <div className="w-full h-full rounded-full bg-white flex items-center justify-center overflow-hidden">
    <img src={botLogo} alt="" aria-hidden="true" className="w-[25px] h-[25px] object-contain" />
  </div>
</div>

              <div
                className="resize-none flex min-w-0 flex-col justify-center items-start bg-transparent"
                style={{
                  width: "100%",
                  flex: "0 1 660px",
                  maxWidth: "660px",
                  minWidth: 0,
                }}
              >
                <div className="flex flex-col gap-3 w-full text-[#10305B] text-sm flex-1" style={{ fontSize: `${fontSize}px` }}>
                    <div className="leading-relaxed min-w-0 w-full">
                    <div className="flex min-w-0 items-start gap-2 w-full">
                      <span className="block font-bold text-[#10305B" style={{ fontSize: `${fontSize}px` }}> </span>
                      <ToggleSwitch isChecked={isChecked} onToggle={onToggle} />

                      {/* Top insights bubble */}
                      <div
                        className="text-left shadow-sm overflow-hidden"
                        style={{
                          width: "fit-content",
                          maxWidth: "100%",
                          flex: "0 1 auto",
                          minHeight: 54,
                          padding: "16px 16px",
                          border: "1px solid #8bb9df",
                          borderRadius: 8,
                          background: "rgba(255, 255, 255, 0.92)",
                        }}
                      >
                        {error ? (
                          <div className="chat-message-markdown prose prose-sm max-w-none break-words whitespace-normal" style={{ textAlign: "left", fontSize: `${fontSize}px` }}>
                            <ReactMarkdown
                              remarkPlugins={[remarkGfm]}
                              components={{
                                a: ({ node, ...props }) => <a {...props} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline" />,
                                table: ({ node, ...props }) => <div className="overflow-x-auto my-2"><table className="min-w-full border-collapse border border-gray-300 text-sm" {...props} /></div>,
                                thead: ({ node, ...props }) => <thead className="bg-[#005856] text-white" {...props} />,
                                th: ({ node, ...props }) => <th className="border border-gray-300 px-3 py-2 text-left font-semibold" {...props} />,
                                td: ({ node, ...props }) => <td className="border border-gray-300 px-3 py-2" {...props} />,
                                tr: ({ node, ...props }) => <tr className="even:bg-gray-50" {...props} />,
                              }}
                            >
                              {typeof chatbotOutput[index] === "string"
                                ? chatbotOutput[index]
                                : chatbotOutput[index]?.output?.text || "An error occurred. Please try again."}
                            </ReactMarkdown>
                          </div>
                        ) : (
                          <div className="min-w-0 flex-1">
                            {chatbotOutput?.[index]?.output?.audio && (
                              <div className="mb-3 border-b border-[#d7e5f1] pb-3">
                                <audio
                                  className="h-9 w-full max-w-[310px]"
                                  ref={(el) => (audioRefs.current[index] = el)}
                                  controls
                                  aria-label="Audio readout of response"
                                  onPlay={() => {
                                    Object.entries(audioRefs.current).forEach(([i, audio]) => {
                                      if (Number(i) !== index && audio && !audio.paused) {
                                        audio.pause();
                                        audio.currentTime = 0;
                                      }
                                    });
                                    setPlayingAudioIndex(index);
                                  }}
                                  onPause={() => { if (playingAudioIndex === index) setPlayingAudioIndex(null); }}
                                  onEnded={() => { if (playingAudioIndex === index) setPlayingAudioIndex(null); }}
                                >
                                  <source src={`data:audio/mp3;base64,${chatbotOutput[index].output.audio}`} type="audio/mp3" />
                                </audio>
                              </div>
                            )}
                            <div className="chat-message-markdown prose prose-sm max-w-none break-words whitespace-normal" style={{ textAlign: "left", fontSize: `${fontSize}px` }}>
                              <ReactMarkdown
                                remarkPlugins={[remarkGfm]}
                                components={{
                                  a: ({ node, ...props }) => <a {...props} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline" />,
                                  table: ({ node, ...props }) => <div className="overflow-x-auto my-2"><table className="min-w-full border-collapse border border-gray-300 text-sm" {...props} /></div>,
                                  thead: ({ node, ...props }) => <thead className="bg-[#005856] text-white" {...props} />,
                                  th: ({ node, ...props }) => <th className="border border-gray-300 px-3 py-2 text-left font-semibold" {...props} />,
                                  td: ({ node, ...props }) => <td className="border border-gray-300 px-3 py-2" {...props} />,
                                  tr: ({ node, ...props }) => <tr className="even:bg-gray-50" {...props} />,
                                }}
                              >
                                {!isChecked
                                  ? (chatbotOutput?.[index]?.output?.text ?? "Something went wrong. Please try again")
                                  : (chatbotOutput?.[index]?.insights ?? "Something went wrong. Please try again")}
                              </ReactMarkdown>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Plotly + Table + Insights card */}
                    {!error && (
                      <>
                        {((chatbotOutput[index]?.image) ||
                          (chatbotOutput[index]?.tableHeading?.length > 0) ||
                          chatbotOutput[index]?.plotlyData) && (
                          <div className="mt-5 w-full pr-0">
                            {(chatbotOutput[index]?.plotlyData || chatbotOutput[index]?.tableHeading?.length > 0) && (
                              <div className="flex flex-row flex-wrap lg:flex-nowrap gap-[10px] w-full min-w-0 overflow-hidden">
                                {chatbotOutput[index]?.plotlyData && (
                                  <div className="w-full lg:w-[60%] h-[min(700px,70vh)] min-h-[320px] flex flex-col px-[10px] py-[10px] text-center border rounded-lg bg-gray-50 shadow-md overflow-hidden" />
                                )}
                                {chatbotOutput[index]?.tableHeading?.length > 0 && (() => {
                                  try {
                                    const parsedData = JSON.parse(chatbotOutput[index]?.output?.json_data);
                                    return (
                                      <SortableTable
                                        headings={chatbotOutput[index]?.tableHeading}
                                        rawData={Array.isArray(parsedData) ? parsedData : []}
                                        isNarrow={!!chatbotOutput[index]?.plotlyData}
                                      />
                                    );
                                  } catch {
                                    return <div className="text-red-500 border p-4 rounded bg-red-50">Error loading table data</div>;
                                  }
                                })()}
                              </div>
                            )}

                            {/* Insights card with copy */}
                            <div className="w-full mt-[20px] px-[10px] py-[10px] text-center border rounded-lg bg-white shadow-md relative">
                              <h1 className="text-[20px] mt-2 font-medium" style={{ fontSize: `${fontSize}px` }}>
                                {chatbotOutput[index]?.insightsLabel || "Insights"}
                              </h1>
                              <div>
                                <div className="chat-message-markdown prose custom-markdown prose-sm max-w-none" style={{ textAlign: "left", fontSize: `${fontSize}px` }}>
                                  <ReactMarkdown>
                                    {!isChecked
                                      ? (chatbotOutput?.[index]?.output?.text ?? "Something went wrong. Please try again")
                                      : (chatbotOutput?.[index]?.insights ?? "Something went wrong. Please try again")}
                                  </ReactMarkdown>
                                </div>

                                {/* Copy button */}
                                <div className="absolute bottom-3 right-4 group">
                                  <CopyToClipboard
                                    text={!isChecked ? chatbotOutput?.[index]?.output?.text || "" : chatbotOutput?.[index]?.insights || ""}
                                    onCopy={() => handleCopy(!isChecked ? chatbotOutput?.[index]?.output?.text || "" : chatbotOutput?.[index]?.insights || "")}
                                  >
                                    <button
                                      type="button"
                                      className="relative inline-flex items-center justify-center p-1 rounded hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#005856] text-gray-500 hover:text-gray-700 transition-colors"
                                      aria-label={!isChecked ? "Copy response to clipboard" : "Copy insights to clipboard"}
                                      title={!isChecked ? "Copy response" : "Copy insights"}
                                    >
                                      <svg className="h-5 w-5 cursor-pointer" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                        <path stroke="none" d="M0 0h24v24H0z" />
                                        <rect x="8" y="8" width="12" height="12" rx="2" />
                                        <path d="M16 8v-2a2 2 0 0 0 -2 -2h-8a2 2 0 0 0 -2 2v8a2 2 0 0 0 2 2h2" />
                                      </svg>
                                      <div className="absolute bottom-full right-0 mb-2 px-2 py-1 text-xs text-white bg-gray-800 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-10 pointer-events-none">
                                        Copy {!isChecked ? "response" : "insights"} text
                                        <div className="absolute top-full right-2 w-0 h-0 border-l-2 border-r-2 border-t-4 border-l-transparent border-r-transparent border-t-gray-800" />
                                      </div>
                                    </button>
                                  </CopyToClipboard>
                                </div>

                                {chatbotOutput?.[index]?.output?.audio ? (
                                  <audio
                                    className="mt-2 ml-3 max-w-[90%]"
                                    ref={(el) => (audioRefs.current[index] = el)}
                                    controls
                                    aria-label="Audio readout of response"
                                    onPlay={() => {
                                      Object.entries(audioRefs.current).forEach(([i, audio]) => {
                                        if (Number(i) !== index && audio && !audio.paused) { audio.pause(); audio.currentTime = 0; }
                                      });
                                      setPlayingAudioIndex(index);
                                    }}
                                    onPause={() => setPlayingAudioIndex(null)}
                                    onEnded={() => setPlayingAudioIndex(null)}
                                  >
                                    <source src={`data:audio/mp3;base64,${chatbotOutput[index].output.audio}`} type="audio/mp3" />
                                  </audio>
                                ) : (
                                  <p className="mt-2 ml-3 text-sm text-gray-500" />
                                )}
                              </div>
                            </div>

                            {chatbotOutput[index]?.ground_data && (
                              <div className="mt-4 px-2 text-left w-full">
                                <button type="button" onClick={() => setIsSourceDataModelOpen(true)} className="text-blue-600 underline hover:text-blue-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#005856]">
                                  Click here to View the source data
                                </button>
                              </div>
                            )}
                          </div>
                        )}
                      </>
                    )}

                    {/* Response timestamp */}
                    {chatbotOutput[index] && (
                      <span className="mt-3 font-medium italic" style={{ fontSize: `${Math.max(fontSize - 2, 10)}px` }}>
                        {responseTimestamps[index] || generateTimestamp()}
                      </span>
                    )}

                    {/* Follow-up question bubbles */}
                    {!loading &&
                      !error &&
                      Array.isArray(chatbotOutput[index]?.follow_up_questions) &&
                      chatbotOutput[index].follow_up_questions.length > 0 &&
                      index === chatbotOutput.length - 1 && (
                        <FollowUpContainer>
                          <FollowUpLabel>Suggested replies:</FollowUpLabel>
                          <FollowUpBubbles>
                            {chatbotOutput[index].follow_up_questions.map((q, qi) => (
                              <FollowUpBubble
                                key={qi}
                                type="button"
                                onClick={() => onFollowUpClick?.(q)}
                                title={q}
                                aria-label={`Ask follow up question: ${q}`}
                              >
                                {q}
                              </FollowUpBubble>
                            ))}
                          </FollowUpBubbles>
                        </FollowUpContainer>
                      )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Loading skeleton */}
          {!chatbotOutput[index] && loading && (
            <div className="flex gap-x-3 text-left mx-4 my-5 max-w-[80%] pb-[18vh]" role="status" aria-live="polite">
              <span className="sr-only">NMDFC Assistant is preparing response...</span>
              <div className="w-[40px] h-[40px] flex items-center justify-center rounded-full overflow-hidden"
                style={{ background: "linear-gradient(135deg, #005856, #00a897)", padding: "2px" }}>
                <div className="w-full h-full rounded-full bg-white flex items-center justify-center overflow-hidden">
                  <img src={botLogo} alt="" aria-hidden="true" className="w-[25px] h-[25px] object-contain" />
                </div>
              </div>
              <div
                className="flex items-center justify-start shadow-sm"
                style={{
                  padding: "10px 16px",
                  border: "1px solid #8bb9df",
                  borderRadius: 8,
                  background: "rgba(255, 255, 255, 0.92)",
                }}
              >
                <img src={loader1} alt="Loading response..." className="w-[40px] h-[40px] object-contain" />
              </div>
            </div>
          )}

          {/* Ambient GIFs */}
          {/* {playingAudioIndex === null && (
            <img className="max-w-full max-w-xl mt-auto h-[15%] sm:h-[25%] ml-auto fixed bottom-[11vh] right-2" src={namaste} alt="namaste" />
          )}
          {playingAudioIndex !== null && (
            <img className="max-w-full max-w-xl mt-auto max-h-[15%] ml-auto fixed bottom-[12vh] right-2 sm:hidden" src={mimic} alt="mimic" />
          )} */}
        </React.Fragment>
      ))}
    </>
  );
};

export default ChatMessages;

// ── Follow-up question styled components ─────────────────────────────

const fadeIn = styled ? undefined : undefined; // placeholder guard

const FollowUpContainer = styled.div`
  margin-top: 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 4px;
`;

const FollowUpLabel = styled.span`
  font-size: 0.72rem;
  font-weight: 600;
  color: #005856;
  letter-spacing: 0.03em;
  text-transform: uppercase;
`;

const FollowUpBubbles = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const FollowUpBubble = styled.button`
  background: linear-gradient(135deg, #e8f8f7 0%, #d1f0ee 100%);
  border: 1.5px solid #a0d9d6;
  color: #005856;
  border-radius: 999px;
  padding: 6px 14px;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  text-align: left;
  line-height: 1.4;
  transition: all 0.18s ease;
  box-shadow: 0 1px 4px rgba(0, 88, 86, 0.1);

  &:hover {
    background: linear-gradient(135deg, #005856 0%, #008787 100%);
    color: #fff;
    border-color: transparent;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 88, 86, 0.25);
  }

  &:active {
    transform: translateY(0);
  }

  &:focus-visible {
    outline: 2px solid #005856;
    outline-offset: 2px;
  }
`;
